//Function for Arrows
const arrowFunction = () => {
  const recGrid = document.querySelector(".cart-drawer__recommendations-grid");
  const prevBtn = document.querySelector(".rec-prev");
  const nextBtn = document.querySelector(".rec-next");

  if (recGrid && prevBtn && nextBtn) {
    const items = [...recGrid.querySelectorAll(".product-card-basic")];
    let currentIndex = 0;

    //Update inactive class
    function updateButtons() {
      prevBtn.classList.toggle("inactive", currentIndex === 0);
      nextBtn.classList.toggle("inactive", currentIndex === items.length - 1);
    }

    //Clicks
    prevBtn.addEventListener("click", () => {
      console.log("click");
      if (currentIndex > 0) {
        currentIndex--;
        items[currentIndex].scrollIntoView({
          behavior: "smooth",
          inline: "start",
        });
        updateButtons();
      }
    });

    nextBtn.addEventListener("click", () => {
      console.log("click");
      if (currentIndex < items.length - 1) {
        currentIndex++;
        items[currentIndex].scrollIntoView({
          behavior: "smooth",
          inline: "start",
        });
        updateButtons();
      }
    });

    updateButtons();
  }
};

//Observer who waits for the element
function observerFunction() {
  const observer = new MutationObserver(() => {
    const candidates = document.querySelectorAll(
      "div[data-cart-drawer-recommendations]",
    );

    candidates.forEach((el) => {
      if (el.querySelector(".cart-drawer__recommendations-grid")) {
        if (!el._observerAttached) {
          el._observerAttached = true;

          // initial trigger
          arrowFunction(el);

          const innerObserver = new MutationObserver(() => {
            if (el.querySelector(".cart-drawer__recommendations-grid")) {
              arrowFunction(el);
            }
          });

          innerObserver.observe(el, {
            childList: true,
            subtree: true,
          });
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

//initial
observerFunction();
